<template>
  <div>
    <Breadcrumb msg1="报表中心" msg2="营业日报" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 15px">
        <el-col :span="6">
          <el-date-picker v-model="date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="getData">统计</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6"><div class="stat"><div class="num">¥{{ data.chargeTotal || 0 }}</div><div class="sub">收费总额</div></div></el-col>
        <el-col :span="6"><div class="stat"><div class="num">¥{{ data.refundTotal || 0 }}</div><div class="sub">退费总额</div></div></el-col>
        <el-col :span="6"><div class="stat"><div class="num">{{ data.glassesOrderCount || 0 }}</div><div class="sub">配镜订单数</div></div></el-col>
        <el-col :span="6"><div class="stat"><div class="num">{{ data.newCustomerCount || 0 }}</div><div class="sub">新增客户</div></div></el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 10px">
        <el-col :span="12"><div class="stat"><div class="num">¥{{ data.glassesAmount || 0 }}</div><div class="sub">配镜金额</div></div></el-col>
      </el-row>
      <el-table :data="data.payBreakdown || []" border size="small" style="margin-top: 15px">
        <el-table-column label="支付方式" prop="payMethod"></el-table-column>
        <el-table-column label="金额" prop="amount"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      date: '',
      data: { payBreakdown: [] }
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.http.get('/reports/daily', { params: { date: this.date } }).then(r => {
        if (r.data.status === 200) this.data = r.data.data
      })
    }
  }
}
</script>

<style scoped>
.stat { background: #f5f7fa; border-radius: 4px; padding: 16px; text-align: center; }
.num { font-size: 22px; color: #409EFF; font-weight: bold; }
.sub { color: #909399; font-size: 13px; margin-top: 4px; }
</style>
